export default [
  {
    path: "/GLkJ6pCeweOVj2qle",
    children: [
      {
        path: "",
        component: () => import("@/views/traits/index.vue"),
        name: "trait-list",
        meta: {
          authRequired: true,
          title: "Traits",
          acc: ["y19235"],
        },
      },
      {
        path: "VAq1HyKlahoF",
        component: () => import("@/views/traits/create.vue"),
        name: "createtrait",
        meta: {
          authRequired: true,
          title: "Create Trait",
          acc: ["y94175"],
        },
      },
      {
        path: "ZasDcYLScTfIwJXvdVS1/:cr?",
        component: () => import("@/views/traits/view.vue"),
        name: "viewtrait",
        meta: {
          authRequired: true,
          title: "View Trait",
          acc: ["y62177"],
          breadcrumb:{
                route: 'trait-list'
            
            },
        },
      },
      {
        path: "ZasDcYLScTfIwJXvdVS11d2cYzTEm4N4",
        component: () => import("@/views/traits/upload.vue"),
        name: "upload_trait",
        meta: {
          authRequired: true,
          title: "Upload Trait",
          acc: null,
          breadcrumb:{
                route: 'trait-list'
            
            },
        },
      },
      {
        path: "VAq1HyKQLF/:cr",
        component: () => import("@/views/traits/update.vue"),
        name: "updatetrait",
        meta: {
          authRequired: true,
          title: "Update Trait",
          acc: ["y42858"],
          breadcrumb:{
                route: 'trait-list'
            
            },
        },
      },
    ],
  },
];
